module.exports = __webpack_public_path__ + "static/polar-pic-55956145ffc8674cab6a3d312777ae95.jpg";